import { campaignInsuranceRepository } from '@/repositories/Index';

class CampaignInsuranceService {
	getCampaignInsuranceDataDetail(params: any) {
		return campaignInsuranceRepository.getCampaignInsuranceDataDetail(params);
	}

	insuranceDailyDataPage(params: any) {
		return campaignInsuranceRepository.insuranceDailyDataPage(params);
	}
	async compensationRedPacketDispatch(params: any) {
		const res = await campaignInsuranceRepository.compensationRedPacketDispatch(params);
		return res;
	}

	getCampaignInsuranceData(params: any) {
		return campaignInsuranceRepository.getCampaignInsuranceData(params)
	}
}

export default CampaignInsuranceService;
